
import { cn } from "@/lib/utils"

function Skeleton({
  className,
  mobileClassName,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  mobileClassName?: string;
}) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-muted", 
        mobileClassName,
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
